<template>
  <v-card>
    <v-form @submit.prevent="submitEditBill()" ref="editBillForm">
      <v-container>
        <v-layout row wrap>
          <dialog-header
            :title="'Edit'"
            :details="`Bill (${bill.status})`"
            :time="editedBill.updatedAt"
          ></dialog-header>
          <flex-sub-header>Bill Header Details</flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field
              label="Reference No."
              v-model="editedBill.externalRef"
              prepend-icon="insert_drive_file"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Xero Reference."
              v-model="editedBill.xeroRef"
              prepend-icon="insert_drive_file"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              label="Status"
              v-model="editedBill.status"
              prepend-icon="info"
              :items="statusItems"
              type="text"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              label="Billing Period"
              v-model="editedBill.billingPeriod"
              prepend-icon="calendar_today"
              :items="allBillingPeriods"
              type="text"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <date-picker-wrapper v-model="editedBill.date" label="Date" color="indigo"></date-picker-wrapper>
          </v-flex>

          <!-- <flex-sub-header>Stat Dec</flex-sub-header>
          <v-flex xs12 sm6 class="flex-container-space-between">
              <v-select
              label="Stat Dec Status"
              :items="statDecStatusItems"
              v-model="editedBill.statDecConfirmed"
              prepend-icon="file_copy"
              >
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 class="flex-container-space-between">
            <v-text-field prepend-icon="note" v-model="editedBill.statDecNotes" label="Stat Dec Notes" type="text"></v-text-field>
          </v-flex>-->
          <v-flex xs12>
            <v-textarea
              rows="1"
              auto-grow
              :rules="internalNotesRules"
              label="Internal Notes"
              v-model="editedBill.internalNotes"
              prepend-icon="note"
              type="text"
            ></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              rows="1"
              auto-grow
              :rules="invoiceNotesRules"
              label="Invoice Notes"
              v-model="editedBill.invoiceNotes"
              prepend-icon="note"
              type="text"
            ></v-textarea>
          </v-flex>

          <flex-sub-header>Bill Line Items</flex-sub-header>
          <v-flex xs12 sm9>
            <v-text-field
              label="Description"
              v-model="editedBill.billLines[0].description"
              prepend-icon="note"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              label="Line Total"
              v-model.number="editedBill.billLines[0].sellTotal"
              prepend-icon="attach_money"
              type="text"
            ></v-text-field>
          </v-flex>

          <template v-if="bill.billLines.length > 1">
            <v-flex xs12 sm9>
              <v-text-field
                label="Admin Fee Description"
                v-model="editedBill.billLines[1].description"
                prepend-icon="note"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-text-field
                label="Admin Fee Total"
                v-model.number="editedBill.billLines[1].sellTotal"
                prepend-icon="attach_money"
                type="text"
              ></v-text-field>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
      <v-container fluid>
        <v-layout>
          <v-flex class="text-xs-right" v-if="!!billTotal">
            <span class="subheading grey--text text--darken-2">Total: ${{billTotal.toFixed(4)}}</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>

        <div>
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit" :loading="loading">Save</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import BillService from '@/services/requests/billService'

// MIXINS
import BillValidation from '@/services/validation/billValidation'
import FormatDates from '@/services/mixins/formatDates'
import BillingPeriods from '@/services/mixins/billingPeriods'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'

export default {
  mixins: [BillValidation, FormatDates, BillingPeriods],
  components: {
    DialogHeader,
    DatePickerWrapper
  },
  data() {
    return {
      editedBill: this.cloneBill(this.bill),
      loading: false,
      units: ['TONNE', 'HOUR', 'DAY', 'EA'],
      statusItems: ['ENTERED', 'COMMITED', 'REVIEW', 'APPROVED', 'CLOSED'],
      statDecStatusItems: ['CONFIRMED', 'REVIEW', 'NOT SET']
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      this.editedBill = this.cloneBill(this.bill)
      this.close()
    },
    submitEditBill() {
      if (!this.$refs.editBillForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    save() {
      this.loading = true
      BillService.updateBill(this.editedBill)
        .then(result => {
          result.data.result.bill.updated = true
          this.$store.commit('bills/updateArrayStateByValue', {
            prop: 'bills',
            value: this.bill,
            editedValue: result.data.result.bill
          })
          this.editedBill = this.cloneBill(result.data.result.bill)
          this.snack({ text: 'Bill was edited!', color: 'green' })
          this.loading = false
          this.close()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          this.snackError()
        })
    },
    calculateTotal(array, prop) {
      return this.$worker.run(
        (array, prop) => {
          var total = 0
          for (var row of array) {
            if (!!row[prop]) {
              var number = Number(row[prop])
              total += number
            }
          }
          return total
        },
        [array, prop]
      )
    },
    cloneBill(bill) {
      var editedBill = Object.assign({}, bill)
      editedBill.date = this.makeComputerDate(editedBill.date)
      return editedBill
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.bill, this.editedBill)) {
        return true
      } else {
        return false
      }
    }
  },
  asyncComputed: {
    async billTotal() {
      return await this.calculateTotal(this.editedBill.billLines, 'sellTotal')
    }
  },
  props: {
    bill: Object
  }
}
</script>

<style>
</style>
